import type {ReactAction} from '@netx/core/bootstrap';
import {faHome} from '@fortawesome/pro-solid-svg-icons';
import {appRouter} from '@netx/core-next/instance/router';
import {AppHomeLabel} from '../locales';

export const appActionHomeRouteIcon = faHome;

/**
 * Route to home
 * @param params
 * @returns Action
 */
export const appActionHomeRoute = (
	params?: Partial<ReactAction>,
): ReactAction => ({
	name: 'app-home-route',
	cb: () => appRouter.home(),
	icon: appActionHomeRouteIcon,
	get label() {
		return AppHomeLabel.ROUTE;
	},
	routeMatch: /^dashboard/,
	...params,
});
